import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_FORM = "CREATE_FORM";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

// TODO: chore task ): Promise<void> clean up hooks with return type void and return response.data;

const removeForm = async (formId: string): Promise<void> => {
  const response = await formsApi.formsControllerRemoveForm(formId);

  return response.data;
};

export const useRemoveForm = (
  user: UserProfileDto | null,
): {
  removeForm: UseMutateFunction<void, Error, string, unknown>;
  removeFormEnabled: boolean;
  isSuccessRemoveForm: boolean;
  isPendingRemoveForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS],
    mutationFn: enabled ? removeForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_FORMS] });
    },
  });

  return {
    removeForm: mutate,
    removeFormEnabled: enabled,
    isSuccessRemoveForm: isSuccess,
    isPendingRemoveForm: isPending,
  };
};
